<template>
  <div id="app">
    <nav class="navbar is-fixed-top" id="main-nav">
      <div class="navbar-brand">
        <div class="navbar-burger burger" data-target="mainNavbar"
            v-bind:class="{ 'is-active': navIsActive}" v-on:click="toggleNavBar()">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="mainNavbar" class="navbar-menu" v-bind:class="{ 'is-active': navIsActive}">
        <div class="navbar-start">
          <router-link class="navbar-item" to="/analyzer" v-on:click.native="toggleNavBar(false)">
            Analyzer
          </router-link>
          <router-link class="navbar-item" to="/generator" v-on:click.native="toggleNavBar(false)">
            Generator
          </router-link>
          <router-link class="navbar-item" to="/reinflector" v-on:click.native="toggleNavBar(false)">
            Reinflector
          </router-link>
        </div>
      </div>
    </nav>

    <router-view/>

    <footer class="footer">
      <hr>
      <div class="container">
        <div class="level">
          <div class="level-item">
            <a href="https://nyuad.nyu.edu/en/research/centers-labs-and-projects/computational-approaches-to-modeling-language-lab.html" target="_blank">
              <img class="footer-logo footer-logo-camel" src="/static/camel.png">
            </a>
          </div>
          <div class="level-item">
            <a href="https://nyuad.nyu.edu" target="_blank">
              <img class="footer-logo" src="/static/nyuad.png">
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      navIsActive: false,
    };
  },
  methods: {
    toggleNavBar(val) {
      if (val === null || val === undefined) {
        this.navIsActive = !this.navIsActive;
      } else {
        this.navIsActive = val;
      }
    },
  },
};
</script>

<style lang="scss">

@import url('https://fonts.googleapis.com/css?family=Changa&subset=arabic');

html {
  width: 100%;
  min-height: 100vh;
}

body {
  padding-top: 52px !important;
}

h1,h2,h3,h4,h5,h6 {
  font-family: 'Changa', sans-serif !important;
  font-weight: 300 !important;
}

h2 {
  color: lighten(#000000, 40%) !important;
}

footer {
  padding-bottom: 3rem !important;
}

@media (min-width: 800px) {
  h1 { font-size: 3.0rem !important; }
  h2 { font-size: 1.88rem !important; }
}

.is-arabic {
  direction: rtl;
}

.is-fullwidth {
  width: 100%;
}

.is-clickable {
  cursor: pointer;
}

.navbar-item img {
  max-height: 2.3rem;
}

.modal{
  padding-top: 52px;
}

.modal-close {
  margin-top: 48px;
}

.footer-logo {
  max-height: 50px;
}

.footer-logo-camel {
  max-height: 80px;
}

.footer-message {
  margin-bottom: 1.5rem !important;
}

.bibliography {
  margin-top: 1.5em;
}

.error-box {
  margin-top: 1.5em;
}

</style>



// WEBPACK FOOTER //
// src/App.vue